export async function countCsvRows(file: File) {
  const content = await file.text();
  return content.split(/\r?\n/).filter((line) => line.trim()).length;
}
